import * as S from './style';

export function SearchNone() {
  return <S.SearchNone>
      검색 결과가 없습니다.
  </S.SearchNone>
}